export default class PartnerFormType
{
	static ORDER = 'order';
	static FEEDBACK = 'feedback';
	static REFUSAL_CHECKOUT = 'refusal_checkout';
	static REFUSAL = 'refusal';
}
